import Footer from "../Footer";
import Header from "./Portfolio/Header";
import Project from "./Portfolio/Project";

export default function Projects() {
  return <>
  <Header />
  <Project />
  <Footer />
</>;
}
